import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { StockPage } from '@/components/Stock/StockPage'
import { stockSearchSchema, withoutSearchDefaults } from '@/components/Stock/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/get-stock/')({
  validateSearch: stockSearchSchema,
  component: StockRoute,
})

function StockRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <StockPage
      search={search}
      onSearchChange={(next) => void navigate(inPageSearch(withoutSearchDefaults, next))}
    />
  )
}
